import { Button, Modal } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ScannedOrderInfo } from '../graphql/checkRepublishConflict';

interface RepublishConflictModalProps {
    visible: boolean;
    orders: ScannedOrderInfo[];
    onStillPublish: () => void;
    onCancel: () => void;
}

const RepublishConflictModal: React.FC<RepublishConflictModalProps> = ({
    visible,
    orders,
    onStillPublish,
    onCancel,
}) => {
    const { t } = useTranslation();

    return (
        <Modal
            open={visible}
            title={
                <span style={{ fontSize: 18, fontWeight: 700 }}>
                    {t('delivery.routes.message.republishConflictTitle')}
                </span>
            }
            onCancel={onCancel}
            footer={[
                <Button key="still-publish" onClick={onStillPublish}>
                    {t('delivery.routes.message.stillPublish')}
                </Button>,
                <Button key="cancel-publish" type="primary" onClick={onCancel}>
                    {t('delivery.routes.message.cancelPublish')}
                </Button>,
            ]}
        >
            <div style={{ maxHeight: '40vh', overflowY: 'auto', marginBottom: 16 }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>
                            <th style={{ textAlign: 'left', padding: '4px 8px', color: '#595959', fontWeight: 'normal', fontSize: 13 }}>
                                {t('delivery.routes.message.republishConflictColumnArea')}
                            </th>
                            <th style={{ textAlign: 'left', padding: '4px 8px', color: '#595959', fontWeight: 'normal', fontSize: 13 }}>
                                {t('delivery.routes.message.republishConflictColumnOrder')}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.map((order, idx) => (
                            <tr key={`${order.trackingNumber}-${idx}`}>
                                <td style={{ padding: '4px 8px', color: '#5b4ef0', fontSize: 13 }}>{order.areaName}</td>
                                <td style={{ padding: '4px 8px', color: '#5b4ef0', fontSize: 13 }}>{order.trackingNumber}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <p style={{ fontWeight: 700, fontSize: 18, margin: 0 }}>
                {t('delivery.routes.message.republishConflictWarning')}
            </p>
        </Modal>
    );
};

export default RepublishConflictModal;